import { DragNDropList } from 'components/DragNDropList';
import { VideoCard } from 'components/VideoCard';
import { getImageURL } from 'utils/tableListFormat';
import { LocalizationProvider, TimeField } from '@mui/x-date-pickers';
import { Box, Typography } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO } from 'date-fns';

const formatVideoToForm = value => {
  if (!value) return;

  return {
    video: {
      videoId: value?.id || value?.video?.videoId,
    },
    sortNumber: value.sortNumber,
    version: value.version,
    nextSuggestionTimeSeconds: value.nextSuggestionTimeSeconds,
    status: value?.status || value?.video?.status,
  };
};

export const DragNDropListOrderCollections = ({
  id,
  videoToCollection,
  setVideoToCollection,
  viewFields,
  setValue,
  getValues,
}) => {
  const syncVideosFormState = items => {
    setValue(
      'videos',
      items.map((item, index) =>
        formatVideoToForm({
          ...item,
          sortNumber: index + 1,
          nextSuggestionTimeSeconds:
            item?.nextSuggestionTimeSeconds <= 60
              ? 60
              : item?.nextSuggestionTimeSeconds,
        })
      )
    );
  };

  const deleteItem = itemId => {
    const updatedVideoToCollection = videoToCollection.filter(
      item => item.id !== itemId
    );
    setVideoToCollection(updatedVideoToCollection);
    syncVideosFormState(updatedVideoToCollection);
  };

  const editItem = itemId => {
    const updateItemStatus = itemId => {
      setVideoToCollection(prevState =>
        prevState.map(item => {
          if (item.id === itemId) {
            return {
              ...item,
              statusEdit: !item.statusEdit, // toggle status
            };
          }
          return item;
        })
      );
    };

    updateItemStatus(itemId);
  };

  const updateTime = (time, id) => {
    if (time && !isNaN(time.getTime())) {
      const hour = time.getHours();
      const minutes = time.getMinutes();
      const seconds = time.getSeconds();
      const totalSeconds = hour * 3600 + minutes * 60 + seconds;
      const safeSeconds = totalSeconds <= 60 ? 60 : totalSeconds;

      const updateItemTime = itemId => {
        setVideoToCollection(prevState => {
          const updatedState = prevState.map(item => {
            if (item.id === itemId) {
              return {
                ...item,
                nextSuggestionTimeSeconds: safeSeconds,
              };
            }
            return item;
          });

          syncVideosFormState(updatedState);
          return updatedState;
        });
      };

      updateItemTime(id);
    }
  };

  const secondsToTime = totalSeconds => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const handleReorder = items => {
    const orderedItems = items.map(i => i.data);
    setVideoToCollection(orderedItems);
    syncVideosFormState(orderedItems);
  };

  return (
    <DragNDropList
      id={id}
      onChange={handleReorder}
      items={videoToCollection.map((i, index) => {
        const formattedTime = secondsToTime(i.nextSuggestionTimeSeconds);

        return {
          id: i.id,
          data: i,
          component: (
            <VideoCard.Root
              key={i.id || i.contentId}
              sx={{ flex: 1, border: '1px solid blue' }}>
              <VideoCard.Image
                variant="square"
                image={getImageURL(i)}
                size="small">
                <VideoCard.CornerAdornment name={'film'} />
              </VideoCard.Image>
              <Box>
                <VideoCard.DescriptionDetail {...i} />
                <Typography
                  variant="body2"
                  lineHeight="20px"
                  marginLeft="24px"
                  fontSize="12px"
                  color="#6F6B7D">
                  {`Limite de Players: ${
                    i?.viewsLimit === 0 ? 'Ilimitado' : i?.viewsLimit
                  }`}
                </Typography>
                <Typography
                  variant="body2"
                  lineHeight="20px"
                  fontSize="12px"
                  marginLeft="24px"
                  color="#6F6B7D">
                  Visualizações: {i?.totalViews}
                </Typography>
              </Box>
              <VideoCard.ActionsContainer>
                <Box>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <TimeField
                      disabled={!i.statusEdit}
                      style={{
                        fontWeight: 500,
                        width: 74,
                        marginRight: '8px',
                        color: 'rgba(111, 107, 125, 1)',
                      }}
                      size="small"
                      variant="standard"
                      fullWidth
                      focused
                      name={'suggestionTimeSeconds'}
                      // onChange={time => updateTime({ time, id })}
                      onChange={time => updateTime(time, i.id)}
                      format="HH:mm:ss"
                      value={parseISO(`1970-01-01T${formattedTime}`)} // Parse the formatted time string
                    />
                  </LocalizationProvider>
                </Box>
                {!i.statusEdit && (
                  <VideoCard.ActionButton
                    action="edit"
                    data-no-dnd="true"
                    disabled={viewFields}
                    onClick={() => {
                      editItem(i.id);
                    }}
                  />
                )}
                {i.statusEdit && (
                  <VideoCard.ActionButton
                    action="save"
                    data-no-dnd="true"
                    disabled={viewFields}
                    onClick={() => {
                      editItem(i.id);
                    }}
                  />
                )}
                <VideoCard.ActionButton action="move" disabled={viewFields} />
                <VideoCard.ActionButton
                  action="delete"
                  disabled={viewFields}
                  data-no-dnd="true"
                  onClick={() => {
                    deleteItem(i.id);
                  }}
                />
              </VideoCard.ActionsContainer>
            </VideoCard.Root>
          ),
        };
      })}
    />
  );
};
